var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('models/dna/DnaModel',['require','underscore','evertrue','ET/ETModel'],function(require) {
  var DnaModel, ETModel, EverTrue, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  ETModel = require("ET/ETModel");
  return DnaModel = (function(_super) {
    __extends(DnaModel, _super);

    function DnaModel() {
      return DnaModel.__super__.constructor.apply(this, arguments);
    }

    DnaModel.prototype.urlRoot = "dna";

    DnaModel.prototype.update = function(key, options) {
      var data;
      if (_.isString(key)) {
        data = (options != null ? options.data_value : void 0) ? options.data_value : this.get(key);
        return this.updateDNAKey(key, data, options);
      } else {
        return _.each(key, (function(_this) {
          return function(value, name) {
            if (options.allow_deletes && (!value || (_.isObject(value) && _.isEmpty(value)))) {
              return _this.deleteDNAKey(name, options);
            } else {
              return _this.updateDNAKey(name, value, options);
            }
          };
        })(this));
      }
    };

    DnaModel.prototype.destroy = function(key, options) {
      this.unset(key);
      return this.deleteDNAKey(key, options);
    };

    DnaModel.prototype.updateDNAKey = function(key, value, orig_opts) {
      var opts;
      opts = {
        success: (function(_this) {
          return function() {
            return _this.updateSettingValue(key, value, orig_opts);
          };
        })(this),
        error: (function(_this) {
          return function() {
            var create_opts;
            create_opts = {
              success: function() {
                return _this.updateSettingValue(key, value, orig_opts);
              }
            };
            return _this.createDNAKey(key, create_opts);
          };
        })(this)
      };
      return this.getSettingsValue(key, opts);
    };

    DnaModel.prototype.updateSettingValue = function(key, value, options) {
      var oid, opts, _ref, _ref1, _ref2;
      if (options != null ? (_ref = options.urlOverride) != null ? (_ref1 = _ref.params) != null ? _ref1.oid : void 0 : void 0 : void 0) {
        oid = options.urlOverride.params.oid;
      } else {
        oid = ((_ref2 = EverTrue.Organization) != null ? _ref2.get("id") : void 0) || "";
      }
      opts = _.extend({
        url: "dna/setting_values/" + key,
        contentType: "application/json",
        type: "PUT",
        data: {
          "oid": oid,
          "value": value || ""
        }
      }, options);
      return EverTrue.api(opts);
    };

    DnaModel.prototype.getSettingsValue = function(key, options) {
      var oid, opts, _ref;
      oid = ((_ref = EverTrue.Organization) != null ? _ref.get("id") : void 0) || "";
      opts = _.extend({
        url: "dna/settings/" + key,
        type: "GET",
        data: {
          "oid": oid
        }
      }, options);
      return EverTrue.api(opts);
    };

    DnaModel.prototype.createDNAKey = function(key, options) {
      var opts;
      opts = _.extend({
        url: "dna/settings",
        contentType: "application/json",
        type: "POST",
        data: {
          "key": key,
          "permissions": "write"
        }
      }, options);
      return EverTrue.api(opts);
    };

    DnaModel.prototype.deleteDNAKey = function(key, options) {
      var oid, opts, _ref;
      oid = ((_ref = EverTrue.Organization) != null ? _ref.get("id") : void 0) || "";
      opts = _.extend({
        url: "dna/setting_values/" + key,
        type: "DELETE",
        data: {
          "oid": oid
        }
      }, options);
      return EverTrue.api(opts);
    };

    DnaModel.prototype.getProducts = function() {
      return _.map(EverTrue.DNA.get("ET.Org.Products"), function(prod) {
        if (prod.name === "givingtree") {
          prod.label = "EverTrue";
        }
        return prod;
      });
    };

    return DnaModel;

  })(ETModel);
});

//# sourceMappingURL=DnaModel.js.map
;
